import Hero from "../components/home/Hero";
import MiddleSection from "../components/home/MiddleSection";
import FeaturedProducts from "../components/home/FeaturedProducts";
import Contact from "../components/home/Contact";
import PartnerHome from "../components/home/PartnersHome";
import Facilities from "../components/home/Facilities";
import { useRef } from "react";

const Home = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="">
      <Hero scrollToContact={scrollToContact} />
      
      <div className="middleSection">
      <MiddleSection />
      <PartnerHome/>
      </div>
      {/* <Facilities/> */}
      <FeaturedProducts />
      <div ref={contactRef}>
        <Contact />
      </div>
    </div>
  );
};

export default Home;